"use client";

import React, { useEffect, useRef, useState } from "react";
import { Shield, Target, Lightbulb, Handshake, BookOpen, Scale } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const valuesData = [{
  title: "salute e sicurezza sui luoghi di lavoro",
  description: "Sosteniamo i più elevati standard etici in ogni pratica legale, garantendo trasparenza e lealtà verso i nostri assistiti.",
  icon: Shield
}, {
  title: "ambiente",
  description: "La nostra missione è fornire consulenza di alto profilo, combinando rigore accademico e pragmatismo operativo.",
  icon: Target
}, {
  title: "\xA0salute e sicurezza alimentare",
  description: "Sfruttiamo le nuove tecnologie e approcci creativi per risolvere le complessità legali del mondo digitale e globale.",
  icon: Lightbulb
}, {
  title: "attività di audit",
  description: "Lavoriamo in stretta sinergia con i nostri clienti, diventando partner strategici per il raggiungimento dei loro obiettivi.",
  icon: Handshake
}, {
  title: "ottenimento delle certificazioni in particolare, secondo i seguenti standard :",
  description: "Chiarezza nei processi e nella comunicazione: assicuriamo che ogni cliente abbia piena consapevolezza delle proprie opzioni legali.",
  icon: BookOpen
}, {
  title: "Etica Professionale",
  description: "Il rispetto delle regole e la tutela del segreto professionale sono alla base di ogni nostra interazione e consulenza.",
  icon: Scale
}];
export default function CoreValues() {
  const headerReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return;
}
function ValueCard({
  value,
  index
}: {
  value: typeof valuesData[0];
  index: number;
}) {
  const reveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const Icon = value.icon;
  return <div ref={reveal.ref} data-index={index} className="h-full transition-all duration-700 ease-out" style={{
    opacity: reveal.isVisible ? 1 : 0,
    transform: reveal.isVisible ? "translateY(0)" : "translateY(40px)",
    transitionDelay: `${index * 100}ms`
  }}>
      <Card className="text-card-foreground flex flex-col h-full bg-card/40 backdrop-blur-md border border-border/60 shadow-sm transition-all duration-500 rounded-2xl overflow-hidden group hover:shadow-lg hover:border-ring/40">
        <CardContent className="p-8 md:p-10 flex flex-col h-full">
          <div className="mb-8 flex items-start justify-between">
            <div className="p-3 rounded-xl bg-background/60 border border-border/40 shadow-2xs group-hover:scale-110 group-hover:bg-background/80 transition-all duration-500">
              <Icon className="w-6 h-6 text-ring" strokeWidth={1.5} />
            </div>
          </div>
          
          <h3 className="text-xl font-sans font-semibold text-foreground mb-4">
            {value.title}
          </h3>
          
          
        </CardContent>
      </Card>
    </div>;
}